import { jsx as ___EmotionJSX } from "@emotion/core";
import * as React from "react";
import Flex from "./Flex";
import Box from "./Box";
import { css } from "./Theme";
import useProp from "../hooks/useProp";
import { validateZoom } from "../utils/index";
import useDimensions from "../hooks/useDimensons";
import useWindowDimensions from "../hooks/useWindowDimensions";
import useDocumentState from "../hooks/useDocumentState";
import CanvasHeader from "./CanvasHeader";
const {
  useRef,
  useEffect,
  useState
} = React;

const Canvas = props => {
  const canvasRef = useRef(null);
  const canvasContentsRef = useRef(null);
  const margin = 40;
  const [showEditor] = useDocumentState("showEditor");
  const [scale] = useProp({
    type: "number",
    value: 100,
    name: "scale",
    section: "Document",
    validate: validateZoom,
    show: false
  });
  const [windowX, windowY] = useWindowDimensions();
  const [canvasX, canvasY] = useDimensions(canvasRef, [windowX, windowY, showEditor]);
  const [contentsX, contentsY] = useDimensions(canvasContentsRef, [scale, windowX, windowY]);
  const canvasStyles = css({
    flex: "1 auto",
    overflow: "auto",
    flexDirection: "column"
  });
  const canvasContainerStyles = css({
    height: "calc(1000px - 100%)",
    flex: "1 auto"
  });
  const canvasInnerStyles = css({
    display: "flex",
    flex: "1 auto",
    backgroundColor: `background.secondary`,
    height: "100%",
    overflow: "scroll",
    justifyContent: canvasX && canvasX >= contentsX + margin * 2 ? "center" : "flex-start",
    alignItems: canvasY && canvasY >= contentsY + margin * 2 ? "center" : "flex-start"
  });
  const canvasContentsStyles = css({
    m: margin
  });
  return ___EmotionJSX(Flex, {
    css: canvasStyles
  }, ___EmotionJSX(CanvasHeader, null), ___EmotionJSX("div", {
    ref: canvasRef,
    css: canvasContainerStyles
  }, ___EmotionJSX(Box, {
    css: canvasInnerStyles
  }, ___EmotionJSX(Box, null, ___EmotionJSX("div", {
    ref: canvasContentsRef,
    css: canvasContentsStyles
  }, props.children)))));
};

export default Canvas;